module.exports = __webpack_public_path__ + "img/icon-question-rating-heart-hover.4e0a70ce.svg";